var map = {
	"./bn/main.yml": 42,
	"./da/main.yml": 43,
	"./de/main.yml": 44,
	"./el/main.yml": 45,
	"./en/main.yml": 46,
	"./es/main.yml": 47,
	"./fr/main.yml": 48,
	"./gd/main.yml": 49,
	"./it/main.yml": 50,
	"./ru/main.yml": 51,
	"./si/main.yml": 52,
	"./tr/main.yml": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;